const WS_PROTOCOL = window.location.protocol === 'https:' ? 'wss://' : 'ws://';
const BACKEND_DOMAIN = "localhost:8080";
const WS_URL = WS_PROTOCOL + BACKEND_DOMAIN;
export const WS_SOCKET_URL = WS_URL + "/";
export const WS_SPEAKER_URL = WS_URL + "/speaker";
export const WS_TRANSCRIBE_URL = WS_URL + "/transcribe";
